export default function lastDate18YearsAgo () {
    const dataCorrente = new Date();
    const dataMeno18Anni =  new Date(dataCorrente.getFullYear() - 18, dataCorrente.getMonth(), dataCorrente.getDate());
    return dataMeno18Anni;
}